module.exports = __webpack_public_path__ + "static/media/Zelle.f71925e2.png";